import React, { useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SettingsIcon from '@material-ui/icons/Settings';
import MessageIcon from '@material-ui/icons/Message';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import { mdiAccountGroup } from '@mdi/js';

// import { AppContext } from '../../common/contexts';
import {
    DASHBOARD_MY_PROFILE,
    DASHBOARD_MY_CALENDAR,
    DASHBOARD_MY_JOBS,
    DASHBOARD_MY_SETTINGS,
    DASHBOARD_MY_MESSAGES,
    DASHBOARD_JOB_CENTER,
    DASHBOARD_TALENT_CENTER,
} from '../../common/constants';

import AfitdMdiIcon from '../../common/elemental/AfitdMdiIcon';

import _get from 'lodash/get';

const styles = theme => ({
    unselected: {
        color: '#000000',
        backgroundColor: '#F0F2F6',
        '&:hover': {
            backgroundColor: '#E0E1E5',
        },
        width: '124px',
        height: '124px',
        borderRadius: '10px',
        border: '2px solid #FFF',
        textTransform: 'none',
        marginBottom: '6px',
        marginLeft: '2px',
        marginRight: '2px',
        // added
        [theme.breakpoints.down('lg')]: { width: '114px', height: '94px' },
    },
    selected: {
        color: '#000000',
        backgroundColor: '#F0F2F6',
        width: '124px',
        height: '124px',
        borderRadius: '10px',
        border: '2px solid #1D8A8B',
        textTransform: 'none',
        marginBottom: '6px',
        marginLeft: '2px',
        marginRight: '2px',
        // added below line
        [theme.breakpoints.down('lg')]: { width: '114px', height: '94px' },
    },
    contents: {
        display: 'flex',
        flexWrap: 'wrap',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        fontWeight: 600,
    },
    icon: {
        width: '100%',
        padding: 0,
        marginBottom: '10px',
    },
    label: {
        width: '100%',
    },
    caption: {
        position: 'absolute',
        right: '24px',
        top: '24px',
        width: '24px',
        height: '24px',
        borderRadius: '100%',
        background: '#fc821f',
        fontSize: '13px',
        lineHeight: '24px',
        color: '#ffffff',
        fontWeight: 'bold',
        // added below line
        [theme.breakpoints.down('lg')]: { right: '8px', top: '8px' },
    },
});

const getIcon = props => {
    const label = _get(props, 'label', '');
    const selected = _get(props, 'selected', false);

    const color = selected ? 'inherit' : 'disabled';

    switch (label) {
        case DASHBOARD_MY_PROFILE:
            return <AccountCircleIcon color={color} style={{ fontSize: 34 }} />;
        case DASHBOARD_MY_CALENDAR:
            return <DateRangeIcon color={color} style={{ fontSize: 34 }} />;
        case DASHBOARD_MY_JOBS:
            return <AssignmentIcon color={color} style={{ fontSize: 34 }} />;
        case DASHBOARD_MY_SETTINGS:
            return <SettingsIcon color={color} style={{ fontSize: 34 }} />;
        case DASHBOARD_MY_MESSAGES:
            return <MessageIcon color={color} style={{ fontSize: 34 }} />;
        case DASHBOARD_JOB_CENTER:
            return <HomeWorkIcon color={color} style={{ fontSize: 34 }} />;
        case DASHBOARD_TALENT_CENTER:
            return <AfitdMdiIcon color={color} style={{ fontSize: 34 }} path={mdiAccountGroup} />;
        default:
            return null;
    }
};

const getCaption = props => {
    const classes = _get(props, 'classes');
    const caption = _get(props, 'caption');

    if (caption) {
        return <figcaption className={classes.caption}>{caption}</figcaption>;
    }

    return null;
};

const NavigationButton = props => {
    // const appContext = useContext(AppContext);

    const { classes, label, selected, onClick /*, caption*/ } = props;

    const rootClassName = selected ? classes.selected : classes.unselected;

    const handleClickButton = useCallback(() => {
        if (onClick) onClick();
    }, [onClick]);

    return (
        <>
            <ButtonBase className={rootClassName} onClick={handleClickButton}>
                <span className={classes.contents}>
                    <figure className={classes.icon}>
                        {getIcon(props)}
                        {getCaption(props)}
                    </figure>
                    <span className={classes.label}>{label}</span>
                </span>
            </ButtonBase>
        </>
    );
};

export default withStyles(styles)(NavigationButton);
